import { render } from "./WebSite.vue?vue&type=template&id=6eddc48c&scoped=true"
import script from "./WebSite.vue?vue&type=script&lang=js"
export * from "./WebSite.vue?vue&type=script&lang=js"

import "./WebSite.vue?vue&type=style&index=0&id=6eddc48c&scoped=true&lang=css"

import exportComponent from "/Users/macpc/Documents/WORK/project/Rail_transit_exper_mental_platform/源代码/实验综合平台/experimentalSynthesisUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eddc48c"]])

export default __exports__